const emailRegExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]{1,64}@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/
const mobileNoRegExp = /^(01[016789])([0-9]{3,4})([0-9]{4})$/
const phoneNoRegExp =  /(?<tel>^0(2|3[1-3]|4[1-4]|5[1-5]|6[1-4])[0-9]{3,4}[0-9]{4}$)|(?<mobile>^01[016789][0-9]{3,4}[0-9]{4}$)|(?<service>^1[568][0-9]{2}[0-9]{4}$)|(?<ums>^030[0-9]{5}[0-9]{4}$)|(?<virtual>^050[0-9]?[0-9]{4}[0-9]{4}$)|(?<voip>^070[0-9]{4}[0-9]{4}$)/
const onlyNumberRegExp = /^[0-9]+$/g
const urlRegExp = /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)$/

export {
  emailRegExp,
  mobileNoRegExp,
  phoneNoRegExp,
  onlyNumberRegExp,
  urlRegExp,
}
